import { render } from "./bottom.vue?vue&type=template&id=1a2620b0&scoped=true"
const script = {}

import "./bottom.vue?vue&type=style&index=0&id=1a2620b0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a2620b0"]])

export default __exports__